/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
// Some default computed bindings methods
/**
@polymerBehavior
*/
export let DefaultComputedBindings = {
  // if(condition, then [, otherwise [, prefix [, postfix]]])
  if: function (condition, then, otherwise, prefix, postfix) {
    otherwise = otherwise || '';
    prefix = prefix || '';
    postfix = postfix || '';
    return '' + prefix + (condition ? then : otherwise) + postfix;
  },

  // if (thing == another) return then; else return otherwise
  ifEqual: function (thing, another, then, otherwise) {
    if (thing == another) {
      return then;
    } else {
      return otherwise;
    }
  },

  // join(array [, separator = ','])
  join: function (array, separator) {
    separator = separator !== undefined ? separator : ',';
    return array.join(separator);
  },

  // concat(thing [, another [, ...]])
  concat: function (thing, another) {
    return Array.prototype.slice.call(arguments).join('');
  },

  // and(x, y [, z [,...]])
  and: function (x, y, z) {
    return !!Array.prototype.slice.call(arguments).reduce(function (x, y) {
      return x && y;
    });
  },

  // or(x, y [, z [,...]])
  or: function (x, y, z) {
    return !!Array.prototype.slice.call(arguments).reduce(function (x, y) {
      return x || y;
    });
  },

  firstValid: function (x, y, z) {
    for (var i = 0; i < arguments.length; i++) {
      if (arguments[i]) {
        return arguments[i];
      }
    }
  },

  // xor(x, y [, z [,...]])
  xor: function (x, y, z) {
    return Array.prototype.slice.call(arguments).reduce(function (x, y) {
      return !x != !y;
    });
  },

  // equal(a, b, strict = false)
  equal: function (a, b, strict) {
    return strict ? a === b : a == b;
  },

  exists(x) {
    return x != null;
  },

  of: function (a, b, c) {
    var val = a && a[b];
    if (c != null) {
      val = val && val[c];
    }
    return val;
  },

  includes: function (a, b) {
    return a.includes(b);
  },

  isOneOf: function (x, ...values) {
    return values.includes(x);
  },

  sum: function (...values) {
    return values.reduce((total, x) => (total += x), 0);
  },

  hasKey: function (x, key) {
    return Object.keys(x || {}).includes(key);
  },

  getItemById: function (id) {
    var id = Array.prototype.slice.call(arguments).join('');
    return this.$[id] || this.$$('#' + id);
  }
};
